import LegalDocumentPage from "./LegalDocumentPage"

export default function CookiePolicyPage() {
    return (
        <LegalDocumentPage
            title="Cookie Policy"
            subtitle="What storage HomeIndex uses and how to change your cookie choices."
            canonicalPath="/cookies"
            sections={[
                {
                    title: "Necessary storage",
                    paragraphs: [
                        "Necessary storage keeps the site working and remembers essential state such as authentication, saved page state, and security-related flows.",
                    ],
                    bullets: [
                        "Login and authentication tokens.",
                        "Saved page state used to resume flows after login.",
                        "Payment handoff state and similar core product state.",
                    ],
                },
                {
                    title: "Analytics storage",
                    paragraphs: [
                        "If you accept analytics, HomeIndex may use PostHog and Google Analytics to understand product usage and improve the site.",
                        "These tools are blocked until you opt in.",
                    ],
                },
                {
                    title: "Marketing storage",
                    paragraphs: [
                        "If you accept marketing, HomeIndex may use Google Ads and related conversion tracking so we can measure campaign performance.",
                        "These tools are also blocked until you opt in.",
                    ],
                },
                {
                    title: "Changing your choice",
                    paragraphs: [
                        "You can open cookie settings from the footer at any time to review or change your selection.",
                        "If you reject non-essential cookies, we clear known analytics and marketing cookies/storage where practical.",
                    ],
                },
            ]}
            note="Cookie storage used by third-party providers can change over time. Review the live vendor settings and legal guidance before publishing."
        />
    )
}
